import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { GuestRoute, ProtectedRoute, RoleRoute } from './guards/RouteGuards';
import { PERMISSIONS, ROLES } from './config/rbac';
import Login from './pages/Login';
import BrandLogin from './pages/BrandLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Brands from './pages/Brands';
import BrandForm from './pages/BrandForm';
import Verifications from './pages/Verifications';
import CouponList from './pages/CouponList';
import CouponForm from './pages/CouponForm';
import CouponGenerate from './pages/CouponGenerate';
import Settings from './pages/Settings';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<GuestRoute portal="super"><Login /></GuestRoute>} />
      <Route path="/brand/login" element={<GuestRoute portal="brand"><BrandLogin /></GuestRoute>} />
      <Route path="/forgot-password" element={<GuestRoute><ForgotPassword /></GuestRoute>} />
      <Route path="/reset-password" element={<GuestRoute><ResetPassword /></GuestRoute>} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route
          path="brands"
          element={
            <RoleRoute roles={[ROLES.SUPER_ADMIN]} permission={PERMISSIONS.BRANDS_VIEW}>
              <Brands />
            </RoleRoute>
          }
        />
        <Route
          path="brands/new"
          element={
            <RoleRoute roles={[ROLES.SUPER_ADMIN]} permission={PERMISSIONS.BRANDS_MANAGE}>
              <BrandForm />
            </RoleRoute>
          }
        />
        <Route
          path="brands/:id"
          element={
            <RoleRoute roles={[ROLES.SUPER_ADMIN]} permission={PERMISSIONS.BRANDS_MANAGE}>
              <BrandForm />
            </RoleRoute>
          }
        />
        <Route
          path="verifications"
          element={
            <RoleRoute permission={PERMISSIONS.VERIFICATION_VIEW}>
              <Verifications />
            </RoleRoute>
          }
        />
        <Route
          path="coupons"
          element={
            <RoleRoute permission={PERMISSIONS.VERIFICATION_VIEW}>
              <CouponList />
            </RoleRoute>
          }
        />
        <Route
          path="coupons/generate"
          element={
            <RoleRoute permission={PERMISSIONS.VERIFICATION_MANAGE}>
              <CouponGenerate />
            </RoleRoute>
          }
        />
        <Route
          path="coupons/:id"
          element={
            <RoleRoute permission={PERMISSIONS.VERIFICATION_MANAGE}>
              <CouponForm />
            </RoleRoute>
          }
        />
        <Route
          path="settings"
          element={
            <RoleRoute permission={PERMISSIONS.SETTINGS_VIEW}>
              <Settings />
            </RoleRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
